import { RoutesEnum } from "../types/RoutesEnum";
import { getAppConfigSetting } from "../utils";

export const ROUTER_BASENAME = RoutesEnum.Root;
export const LEGIT_SERVICE_CONFIG = {
  useSessionLogin: false,
  apiUrl: getAppConfigSetting("legitApiUrl"),
};

export const OKTA_DOMAIN = getAppConfigSetting("oktaUrl");
export const CLIENT_ID = getAppConfigSetting("clientId");

export const ISSUER = getAppConfigSetting("oktaIssuer");
export const HOST = window.location.href;
export const REDIRECT_URI = `${window.location.origin}/${ROUTER_BASENAME}`;
export const LOGOUT_REDIRECT_URI = `${getAppConfigSetting(
  "appsUrl"
)}/${ROUTER_BASENAME}`;
export const SCOPES = "openid profile email";

export const OKTA_CONFIG = {
  issuer: ISSUER,
  clientId: CLIENT_ID,
  redirectUri: REDIRECT_URI,
  scopes: SCOPES.split(/\s+/),
  pkce: true,
};

export const OKTA_WIDGET_CONFIG = {
  baseUrl: OKTA_DOMAIN,
  clientId: CLIENT_ID,
  redirectUri: REDIRECT_URI,
  authParams: {
    issuer: ISSUER,
    pkce: true,
    scope: SCOPES.split(/\s+/),
  },
  logo: false,
  i18n: {
    en: {
      "primaryauth.title": "Sign In",
      "primaryauth.username.placeholder": "E-mail Address *",
      "primaryauth.password.placeholder": "Password *",
      "error.username.required": "Please enter an e-mail address",
      "error.password.required": "Please use your Okta password",
      "oform.error.unexpected":
        "Please use your e-mail address and Okta password",
      "primaryauth.submit": "Sign In",
    },
  },
  colors: {
    brand: "#4079BC",
  },
};
